import { AstralArena } from "../features/vabank/AstralArena.jsx";
import { VaBankHistory } from "../features/vabank/VaBankHistory.jsx";
import { IconHistory } from "../components/icons.jsx";
import { getAuthData } from "../features/auth/session.js";
import "./VaBankPage.css";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { IconCards } from "../components/icons.jsx";
import { IconCoin } from "../components/icons.jsx";
import { IconDiamond } from "../components/icons.jsx";
import { IconTrophy } from "../components/icons.jsx";
import { IconCheck } from "../components/icons.jsx";
export const qx = "_page_1vwda_1";
export const Gx = "_header_1vwda_1";
export const Yx = "_pot_1vwda_1";
export const Xx = "_arena_1vwda_1";
export const Qx = "_arenaLabel_1vwda_1";
export const Zx = "_countdown_1vwda_1";
export const Vx = "_zone_1vwda_1";
export const $x = "_playerCard_1vwda_1";
export const Kx = "_zone0_1vwda_1";
export const Jx = "_zone1_1vwda_1";
export const Wx = "_zone2_1vwda_1";
export const Ix = "_zone3_1vwda_1";
export const Fx = "_winner_1vwda_1";
export const Px = "_lost_1vwda_1";
export const e3 = "_orb_1vwda_1";
export const t3 = "_fair_1vwda_1";
export const a3 = "_players_1vwda_1";
export const l3 = "_join_1vwda_1";
export const n3 = "_yourCard_1vwda_1";
export const s3 = "_result_1vwda_1";
export const i3 = "_zone4_1vwda_3";
export const c3 = "_zone5_1vwda_3";
export const u3 = "_demoButton_1vwda_3";
export const o3 = "_startButton_1vwda_3";
export const r3 = "_bet_1vwda_4";
export const d3 = "_betHint_1vwda_4";
export const f3 = "_currencySwitch_1vwda_4";
export const h3 = "_selectedCurrency_1vwda_4";
export const m3 = "_betAmount_1vwda_4";
export const p3 = "_coinIcon_1vwda_5";
export const v3 = "_crystalIcon_1vwda_5";
export const b3 = "_gemIcon_1vwda_6";
export const g3 = "_spinIcon_1vwda_7";
export const y3 = "_placeBet_1vwda_8";
export const _3 = "_betError_1vwda_10";
export const j3 = "_territories_1vwda_11";
export const x3 = "_winnerSegment_1vwda_12";
export const S3 = "_lostSegment_1vwda_12";
export const w3 = "_shapedTerritories_1vwda_15";
export const N3 = "_zoneLabel0_1vwda_15";
export const T3 = "_zoneLabel1_1vwda_15";
export const C3 = "_zoneLabel2_1vwda_15";
export const M3 = "_zoneLabel3_1vwda_15";
export const A3 = "_zoneLabel4_1vwda_15";
export const E3 = "_zoneLabel5_1vwda_15";
export const D3 = "_playerAvatar_1vwda_16";
export const z3 = "_smallZone_1vwda_17";
export const O3 = "_smallCorner0_1vwda_17";
export const k3 = "_smallCorner1_1vwda_17";
export const R3 = "_smallCorner2_1vwda_17";
export const B3 = "_smallCorner3_1vwda_17";
export const U3 = "_cardPicker_1vwda_18";
export const H3 = "_selectedCard_1vwda_18";
export const L3 = "_quickBet_1vwda_20";
export const q3 = "_online_1vwda_21";
export const G3 = "_headerOnline_1vwda_22";
export const Y3 = "_wonCards_1vwda_26";
export const Qe = {
  page: qx,
  header: Gx,
  pot: Yx,
  arena: Xx,
  arenaLabel: Qx,
  countdown: Zx,
  zone: Vx,
  playerCard: $x,
  zone0: Kx,
  zone1: Jx,
  zone2: Wx,
  zone3: Ix,
  winner: Fx,
  lost: Px,
  orb: e3,
  fair: t3,
  players: a3,
  join: l3,
  yourCard: n3,
  result: s3,
  zone4: i3,
  zone5: c3,
  demoButton: u3,
  startButton: o3,
  bet: r3,
  betHint: d3,
  currencySwitch: f3,
  selectedCurrency: h3,
  betAmount: m3,
  coinIcon: p3,
  crystalIcon: v3,
  gemIcon: b3,
  spinIcon: g3,
  placeBet: y3,
  betError: _3,
  territories: j3,
  winnerSegment: x3,
  lostSegment: S3,
  shapedTerritories: w3,
  zoneLabel0: N3,
  zoneLabel1: T3,
  zoneLabel2: C3,
  zoneLabel3: M3,
  zoneLabel4: A3,
  zoneLabel5: E3,
  playerAvatar: D3,
  smallZone: z3,
  smallCorner0: O3,
  smallCorner1: k3,
  smallCorner2: R3,
  smallCorner3: B3,
  cardPicker: U3,
  selectedCard: H3,
  quickBet: L3,
  online: q3,
  headerOnline: G3,
  wonCards: Y3
};
export const Rt = (...u) => u.map(([o, m]) => ({
  x: o,
  y: m
}));
export const Mm = {
  2: {
    players: 2,
    origin: {
      x: 51,
      y: 50
    },
    rotation: 42,
    avatarAnchors: Rt([28, 34], [74, 68])
  },
  3: {
    players: 3,
    origin: {
      x: 50,
      y: 58
    },
    rotation: 225,
    avatarAnchors: Rt([27, 28], [73, 29], [50, 76])
  },
  4: {
    players: 4,
    origin: {
      x: 46,
      y: 46
    },
    rotation: 18,
    avatarAnchors: Rt([22, 25], [77, 24], [76, 76], [23, 77])
  },
  5: {
    players: 5,
    origin: {
      x: 56,
      y: 52
    },
    rotation: 271,
    avatarAnchors: Rt([22, 24], [62, 19], [82, 50], [63, 81], [22, 75])
  },
  6: {
    players: 6,
    origin: {
      x: 48,
      y: 54
    },
    rotation: 138,
    avatarAnchors: Rt([22, 23], [52, 18], [80, 28], [80, 72], [49, 83], [20, 72])
  },
  7: {
    players: 7,
    origin: {
      x: 54,
      y: 48
    },
    rotation: 315,
    avatarAnchors: Rt([20, 22], [47, 17], [76, 23], [84, 51], [72, 80], [43, 83], [18, 66])
  },
  8: {
    players: 8,
    origin: {
      x: 49,
      y: 51
    },
    rotation: 94,
    avatarAnchors: Rt([20, 21], [45, 17], [72, 21], [84, 45], [79, 76], [54, 84], [27, 78], [17, 51])
  },
  9: {
    players: 9,
    origin: {
      x: 53,
      y: 54
    },
    rotation: 196,
    avatarAnchors: Rt([18, 22], [39, 16], [65, 18], [82, 34], [84, 62], [68, 82], [42, 84], [20, 71], [16, 46])
  },
  10: {
    players: 10,
    origin: {
      x: 50,
      y: 50
    },
    rotation: 332,
    avatarAnchors: Rt([18, 20], [37, 16], [61, 16], [81, 28], [85, 52], [78, 76], [60, 84], [37, 84], [18, 73], [15, 47])
  },
  11: {
    players: 11,
    origin: {
      x: 52,
      y: 48
    },
    rotation: 66,
    avatarAnchors: Rt([16, 20], [33, 15], [53, 14], [72, 19], [85, 36], [85, 60], [73, 79], [53, 85], [32, 81], [16, 65], [13, 43])
  },
  12: {
    players: 12,
    origin: {
      x: 48,
      y: 52
    },
    rotation: 154,
    avatarAnchors: Rt([15, 20], [31, 14], [51, 13], [70, 17], [83, 32], [87, 51], [81, 71], [67, 84], [47, 87], [28, 81], [15, 65], [12, 43])
  },
  13: {
    players: 13,
    origin: {
      x: 55,
      y: 51
    },
    rotation: 243,
    avatarAnchors: Rt([15, 18], [29, 13], [47, 12], [65, 14], [80, 24], [87, 41], [87, 60], [78, 77], [62, 85], [44, 87], [27, 80], [15, 65], [11, 42])
  },
  14: {
    players: 14,
    origin: {
      x: 46,
      y: 49
    },
    rotation: 21,
    avatarAnchors: Rt([14, 18], [27, 12], [43, 11], [59, 12], [74, 19], [85, 33], [88, 50], [83, 68], [71, 82], [55, 87], [38, 85], [23, 76], [13, 62], [10, 40])
  },
  15: {
    players: 15,
    origin: {
      x: 50,
      y: 53
    },
    rotation: 291,
    avatarAnchors: Rt([14, 17], [26, 11], [40, 10], [55, 11], [70, 15], [81, 26], [87, 41], [87, 58], [80, 74], [67, 84], [51, 88], [35, 84], [22, 74], [13, 60], [10, 39])
  }
};
export const X3 = u => Mm[Math.min(15, Math.max(2, u))] || Mm[15];
export const Q3 = 100;
export const Co = {
  metacoin: {
    label: "MetaCoins",
    symbol: "M"
  },
  crystal: {
    label: "Гемы",
    symbol: "💎"
  },
  gem: {
    label: "Рубины",
    symbol: "♦"
  },
  spin: {
    label: "Крутки",
    symbol: "↻"
  },
  card: {
    label: "Карты",
    symbol: "🃏"
  }
};
/** @param {{ onBack?: () => void, onBalanceChange: (balance: { metacoins: number, crystals: number, spins: number, gems: number }) => void }} props */
export function VaBankPage({
  onBack,
  onBalanceChange: u
}) {
  const [historyOpen, setHistoryOpen] = React.useState(false);
  const backButton = window.Telegram?.WebApp?.BackButton;
  React.useEffect(() => {
    if (!backButton || !onBack) return;
    backButton.show();
    const goBack = historyOpen ? () => setHistoryOpen(false) : onBack;
    backButton.onClick(goBack);
    return () => {
      backButton.offClick(goBack);
      backButton.hide();
    };
  }, [backButton, onBack, historyOpen]);
  const [o, m] = React.useState(null),
    [r, g] = React.useState(null),
    [j, B] = React.useState(0),
    [U, N] = React.useState(0),
    [y, X] = React.useState(0),
    [M, R] = React.useState(15),
    [H, Y] = React.useState("metacoin"),
    [P, W] = React.useState(10),
    [ee, ie] = React.useState(1e3),
    [w, I] = React.useState(1e3),
    [ne, oe] = React.useState(1),
    [T, D] = React.useState({
      metacoins: 0,
      crystals: 0,
      gems: 0,
      spins: 0
    }),
    [le, te] = React.useState([]),
    [Z, V] = React.useState(null),
    [ae, Te] = React.useState(!1),
    [je, k] = React.useState(""),
    O = React.useRef(!0),
    L = o?.players.length ?? 0,
    se = o?.me?.joined ?? !1;
  React.useEffect(() => {
    if (o?.status !== "finished") return;
    const roomId = o.id;
    const timer = window.setTimeout(() => {
      O.current = true;
      g(roomId);
      m(null);
    }, 5000);
    return () => window.clearTimeout(timer);
  }, [o?.id, o?.status]);
  React.useEffect(() => {
    if (!o?.startsAt) return;
    const me = () => {
      const re = Math.max(0, Math.ceil((Date.parse(o.startsAt) - (Date.now() + y)) / 1e3));
      R(re);
    };
    me();
    const K = window.setInterval(me, 250);
    return () => window.clearInterval(K);
  }, [o?.startsAt, y]), React.useEffect(() => {
    const me = getAuthData();
    H !== "card" || !me || fetch("/api/vabank/cards", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        initData: me
      })
    }).then(K => K.ok ? K.json() : {
      cards: []
    }).then(K => {
      te(K.cards), V(re => K.cards.find(S => S.id === re?.id) ?? K.cards[0] ?? null);
    }).catch(() => te([]));
  }, [H, o?.status]), React.useEffect(() => {
    const me = getAuthData();
    if (!me) return;
    let K = !1;
    const re = async () => {
      try {
        const ve = O.current,
          we = await fetch("/api/vabank/room", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              initData: me,
              currency: H,
              preferActive: ve
            })
          });
        if (!we.ok) return;
        const ye = await we.json();
        if (K) return;
        ve && (O.current = !1, ye.room?.bankCurrency && ye.room.bankCurrency !== H && Y(ye.room.bankCurrency)), o?.status !== "finished" && (ye.room ? m(ye.room.id === r ? null : ye.room) : o?.status !== "cancelled" && m(null)), B(ye.room?.gamesTotal ?? ye.gamesTotal ?? 0), N(ye.room?.onlineSpectators ?? ye.onlineSpectators ?? 0), ye.balance && (D(ye.balance), u(ye.balance)), ye.room && X(Date.parse(ye.room.serverTime) - Date.now());
      } catch {}
    };
    re();
    const S = o?.status === "waiting" || !o ? 3e3 : o?.status === "countdown" ? 1e3 : o?.status === "locked" || o?.status === "playing" ? 700 : 8e3,
      xe = window.setInterval(() => {
        re();
      }, S);
    return () => {
      K = !0, window.clearInterval(xe);
    };
  }, [H, o?.status, r]);
  const C = H === "metacoin" ? P : H === "crystal" ? ee : H === "gem" ? w : H === "spin" ? ne : Z?.valueCrystals ?? 0,
    f = H === "metacoin" ? C * Q3 : C,
    h = se ? f : 0,
    p = o?.bankCurrency ?? H,
    G = o?.totalAmount ?? h,
    F = o?.gameNumber ?? j,
    ce = async () => {
      const me = getAuthData();
      if (!(!me || !o)) try {
        const K = await fetch("/api/vabank/settle", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            initData: me,
            roomId: o.id
          })
        });
        if (!K.ok) return;
        const re = await K.json();
        re.room && m(re.room), re.balance && (D(re.balance), u(re.balance));
      } catch {}
    },
    ue = o?.status ?? "waiting",
    Me = ue === "waiting" || ue === "countdown",
    Re = me => {
      if (H === "card") return;
      const K = H === "metacoin" ? 5 : H === "spin" ? 1 : 1e3,
        re = H === "metacoin" ? 10 : H === "spin" ? 1 : 1e3,
        S = H === "metacoin" ? P : H === "crystal" ? ee : H === "gem" ? w : ne,
        xe = H === "metacoin" ? T.metacoins : H === "crystal" ? T.crystals : H === "gem" ? T.gems : T.spins,
        ve = me === "all" ? xe : S * me,
        we = Math.max(re, Math.min(Math.floor(ve / K) * K, Math.floor(xe / K) * K));
      H === "metacoin" ? W(we) : H === "crystal" ? ie(we) : H === "gem" ? I(we) : oe(we);
    },
    wt = async () => {
      const me = getAuthData();
      if (!me) {
        k("Откройте ВА-БАНК через Telegram, чтобы создать комнату.");
        return;
      }
      Te(!0), k("");
      try {
        if (H === "card" && !Z) throw new Error("Выберите карту");
        const K = await fetch("/api/vabank/stake", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              initData: me,
              currency: H,
              amount: C,
              cardId: Z?.id
            })
          }),
          re = await K.json();
        if (!K.ok || !re.room) throw new Error(re.error || "Не удалось создать комнату");
        m(re.room), g(null), B(re.room.gamesTotal), re.balance && (D(re.balance), u(re.balance)), X(Date.parse(re.room.serverTime) - Date.now());
      } catch (K) {
        k(K instanceof Error ? K.message : "Не удалось создать комнату");
      } finally {
        Te(!1);
      }
    };
  return jsxRuntime.jsxs("section", {
    className: Qe.page,
    children: [historyOpen && <VaBankHistory onClose={() => setHistoryOpen(false)} />, jsxRuntime.jsx("header", {
      className: Qe.header,
      children: jsxRuntime.jsx("span", {
        children: jsxRuntime.jsxs("b", {
          children: ["ВА-БАНК ", jsxRuntime.jsxs("em", {
            children: ["#", F || "—"]
          }), jsxRuntime.jsxs("i", {
            className: Qe.headerOnline,
            children: [jsxRuntime.jsx("em", {}), o?.onlineSpectators ?? U]
          }), <button className="vabank-history-tool" onClick={() => setHistoryOpen(true)} aria-label="История игр Ва-банк"><IconHistory />История</button>]
        })
      })
    }), jsxRuntime.jsx(VaBankPot, {
      joined: L,
      total: G,
      currency: p
    }), jsxRuntime.jsx(VaBankArena, {
      status: ue,
      countdown: M,
      players: o?.players ?? [],
      layoutSeed: o?.layoutSeed,
      result: o?.result,
      startsAt: o?.startsAt,
      serverOffset: y,
      onAnimationDone: () => {
        ce();
      },
      onContinue: () => {
        o && (g(o.id), m(null));
      }
    }), jsxRuntime.jsxs("section", {
      className: Qe.bet,
      children: [jsxRuntime.jsx("div", {
        className: Qe.currencySwitch,
        children: Object.keys(Co).map(me => jsxRuntime.jsx("button", {
          className: H === me ? Qe.selectedCurrency : "",
          onClick: () => {
            Y(me), m(null), g(null);
          },
          "aria-label": Co[me].label,
          title: Co[me].label,
          children: jsxRuntime.jsx(VaBankCurrencyIcon, {
            currency: me
          })
        }, me))
      }), H === "card" ? jsxRuntime.jsx("div", {
        className: Qe.cardPicker,
        children: le.length ? le.map(me => jsxRuntime.jsxs("button", {
          className: Z?.id === me.id ? Qe.selectedCard : "",
          onClick: () => V(me),
          children: [jsxRuntime.jsx(IconCards, {}), jsxRuntime.jsxs("span", {
            children: [jsxRuntime.jsx("b", {
              children: me.name
            }), jsxRuntime.jsxs("small", {
              children: [me.rarity, " · #", me.cardNumber ?? "—", " · ", me.valueCrystals.toLocaleString("ru-RU"), " 💎"]
            })]
          })]
        }, me.id)) : jsxRuntime.jsx("small", {
          children: "Нет доступных LIMITED или Mystic карт"
        })
      }) : jsxRuntime.jsxs("div", {
        className: Qe.betAmount,
        children: [jsxRuntime.jsx("button", {
          disabled: !Me,
          onClick: () => {
            H === "metacoin" ? W(me => Math.max(10, me - 5)) : H === "crystal" ? ie(me => Math.max(1e3, me - 1e3)) : H === "gem" ? I(me => Math.max(1e3, me - 1e3)) : oe(me => Math.max(1, me - 1));
          },
          "aria-label": "Уменьшить ставку",
          children: "−"
        }), jsxRuntime.jsxs("b", {
          children: [C.toLocaleString("ru-RU"), " ", jsxRuntime.jsx("em", {
            children: jsxRuntime.jsx(VaBankCurrencyIcon, {
              currency: H
            })
          })]
        }), jsxRuntime.jsx("button", {
          disabled: !Me,
          onClick: () => {
            H === "metacoin" ? W(me => me + 5) : H === "crystal" ? ie(me => me + 1e3) : H === "gem" ? I(me => me + 1e3) : oe(me => me + 1);
          },
          "aria-label": "Увеличить ставку",
          children: "+"
        })]
      }), H !== "card" && jsxRuntime.jsxs("div", {
        className: Qe.quickBet,
        children: [jsxRuntime.jsx("button", {
          disabled: !Me,
          onClick: () => Re(2),
          children: "×2"
        }), jsxRuntime.jsx("button", {
          disabled: !Me,
          onClick: () => Re(10),
          children: "×10"
        }), jsxRuntime.jsx("button", {
          disabled: !Me,
          onClick: () => Re("all"),
          children: "All-in"
        })]
      }), jsxRuntime.jsx("button", {
        className: Qe.placeBet,
        disabled: ae || !(Me || ue === "finished" || ue === "cancelled"),
        onClick: () => {
          wt();
        },
        children: ae ? "Создаём комнату…" : ue === "locked" ? "Ставки закрыты" : ue === "playing" ? "Игра идёт" : ue === "settling" ? "Подводим итоги…" : ue === "finished" ? "Играть снова" : ue === "cancelled" ? "Новая игра" : se ? "Обновить ставку" : "Поставить"
      }), je && jsxRuntime.jsx("small", {
        className: Qe.betError,
        children: je
      })]
    })]
  });
}
export function VaBankCurrencyIcon({
  currency: u
}) {
  return u === "metacoin" ? jsxRuntime.jsx("span", {
    className: Qe.coinIcon,
    children: jsxRuntime.jsx(IconCoin, {})
  }) : u === "card" ? jsxRuntime.jsx("span", {
    className: Qe.crystalIcon,
    children: jsxRuntime.jsx(IconCards, {})
  }) : u === "spin" ? jsxRuntime.jsx("span", {
    className: Qe.spinIcon,
    children: jsxRuntime.jsx(IconCards, {})
  }) : u === "gem" ? jsxRuntime.jsx("span", {
    className: Qe.gemIcon,
    children: jsxRuntime.jsx(IconDiamond, {})
  }) : jsxRuntime.jsx("span", {
    className: Qe.crystalIcon,
    children: jsxRuntime.jsx(IconDiamond, {})
  });
}
export function VaBankPot({
  joined: u,
  total: o,
  currency: m
}) {
  return jsxRuntime.jsxs("section", {
    className: Qe.pot,
    children: [jsxRuntime.jsxs("span", {
      children: [jsxRuntime.jsx("small", {
        children: "БАНК"
      }), jsxRuntime.jsxs("b", {
        children: [jsxRuntime.jsx("em", {
          children: jsxRuntime.jsx(VaBankCurrencyIcon, {
            currency: m
          })
        }), o.toLocaleString("ru-RU")]
      })]
    }), jsxRuntime.jsxs("span", {
      children: [jsxRuntime.jsx("small", {
        children: "ИГРОКИ"
      }), jsxRuntime.jsx("b", {
        children: u
      })]
    })]
  });
}
export function VaBankArena(props) {
  return <AstralArena {...props} layout={X3(props.players.length)} Ball={VaBankBall} />;
}
export const xs = (u, o) => parseInt(u.slice(o, o + 4), 16) / 65535;
export function reflectCoordinate(u, o, m, r) {
  return r > 0 ? m % 2 === 0 ? m * o + u : (m + 1) * o - u : m % 2 === 0 ? -m * o - u : -(m + 1) * o + u;
}
export function foldCoordinate(u, o) {
  const m = o * 2,
    r = (u % m + m) % m;
  return r <= o ? r : m - r;
}
export function createArenaTrajectory(u, o, m) {
  const M = o - 5,
    R = m - 7,
    H = 2 + Math.floor(xs(u, 0) * 3),
    Y = 1 + Math.floor(xs(u, 4) * 3),
    P = reflectCoordinate(M, 90, H, xs(u, 8) > .5 ? 1 : -1),
    W = reflectCoordinate(R, 86, Y, xs(u, 12) > .5 ? 1 : -1),
    ee = new Set([0, 1]),
    ie = (w, I, ne) => {
      const oe = Math.min(w, I),
        T = Math.max(w, I);
      for (let D = Math.ceil(oe / ne) * ne; D < T; D += ne) {
        const le = (D - w) / (I - w);
        le > 1e-4 && le < .9999 && ee.add(Number(le.toFixed(8)));
      }
    };
  return ie(45, P, 90), ie(43, W, 86), [...ee].sort((w, I) => w - I).map(w => ({
    x: 5 + foldCoordinate(45 + (P - 45) * w, 90),
    y: 7 + foldCoordinate(43 + (W - 43) * w, 86),
    t: w
  }));
}
export function VaBankBall({
  seed: u,
  roll: o,
  maxRoll: m,
  finalX: r,
  finalY: g,
  startedAt: j,
  serverOffset: B,
  zoneOrigin: U,
  onDone: N,
  onPosition
}) {
  const [y, X] = React.useState({
      x: 50,
      y: 50,
      angle: 0,
      scale: 1
    }),
    M = React.useRef(null),
    R = React.useRef(N),
    positionCallback = React.useRef(onPosition);
  positionCallback.current = onPosition;
  return React.useEffect(() => {
    R.current = N;
  }, [N]), React.useEffect(() => {
    const H = Math.max(5, Math.min(95, r ?? o / Math.max(1, m) * 100)),
      Y = Math.max(7, Math.min(93, g ?? 30 + xs(u, 24) * 40)),
      P = createArenaTrajectory(u, H, Y),
      W = Date.parse(j),
      ee = I => {
        if (I <= 5200) return .72 * I / 5200;
        const D = Math.max(0, Math.min(1, (I - 5200) / 1800)),
          le = .72 * 1800 / 5200;
        return (2 * D * D * D - 3 * D * D + 1) * .72 + (D * D * D - 2 * D * D + D) * le + (-2 * D * D * D + 3 * D * D);
      },
      ie = I => {
        const ne = Math.min(P.length - 2, P.findIndex((te, Z) => Z > 0 && I <= te.t) - 1),
          oe = ne < 0 ? P.length - 2 : ne,
          T = P[oe],
          D = P[oe + 1],
          le = (I - T.t) / Math.max(1e-5, D.t - T.t);
        return {
          x: T.x + (D.x - T.x) * le,
          y: T.y + (D.y - T.y) * le,
          angle: Math.atan2(D.y - T.y, D.x - T.x) * 180 / Math.PI
        };
      },
      w = I => {
        const ne = Math.max(0, Date.now() + B - W),
          oe = Math.min(7e3, ne),
          T = ie(ee(oe));
        positionCallback.current?.(T, oe);
        X({
          x: T.x,
          y: T.y,
          angle: T.angle,
          scale: oe > 5200 ? 1 + (oe - 5200) / 1800 * .18 : 1
        }), ne < 7400 ? M.current = requestAnimationFrame(w) : R.current();
      };
    return M.current = requestAnimationFrame(w), () => {
      M.current && cancelAnimationFrame(M.current);
    };
  }, [u, o, m, r, g, j, B, U.x, U.y, U.rotation]), jsxRuntime.jsxs("i", {
    className: Qe.orb,
    style: {
      left: `${y.x}%`,
      top: `${y.y}%`,
      "--motion-angle": `${y.angle}deg`,
      "--orb-scale": y.scale
    },
    children: [jsxRuntime.jsx("i", {}), jsxRuntime.jsx("i", {})]
  });
}
